import { render, staticRenderFns } from "./add2.vue?vue&type=template&id=906bae3c&scoped=true&"
import script from "./add2.vue?vue&type=script&lang=js&"
export * from "./add2.vue?vue&type=script&lang=js&"
import style0 from "./add2.vue?vue&type=style&index=0&id=906bae3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906bae3c",
  null
  
)

export default component.exports